module.exports = __webpack_public_path__ + "img/editApplication_a.35f8c240.png";